export default {
  'CLEANING': [
    {
      title: true,
      name: 'Master',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      },
      role: ['admin']
    },
    {
      name: 'Reservations',
      url: '/reservations',
      icon: 'icon-notebook',
      role: ['admin']
    },
    {
      name: 'Vehicle Maintenance',
      url: '/cleaning',
      icon: 'icon-wrench',
      role: ['ops-cleaning']
    },
  ]
}
